/** @jsx jsx */
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { Box } from '@balance-web/box';
import type { CSSObject } from '@balance-web/core';
import { jsx } from '@balance-web/core';
import { useTheme } from '@balance-web/theme';

export const Divider = () => {
  const { semantic } = useTheme();

  const styles: CSSObject = {
    height: 1,
    backgroundColor: semantic.colour.surface.neutral.border,
  };

  return (
    <Box paddingY="small">
      <DropdownMenuPrimitive.Separator css={styles} />
    </Box>
  );
};
